import styled from "styled-components";
import { ButtonBaseStyles, ButtonType, RightSplitButtonStyles  } from "./Button";

export const LinkButton = styled.a`
    ${ButtonBaseStyles};
`

export const RightSplitLinkButton = styled.a`
    ${RightSplitButtonStyles};
`

LinkButton.defaultProps = {
    variant: ButtonType.solid
}

RightSplitLinkButton.defaultProps = {
    variant: ButtonType.solid
}